var exports = {
  "um": "StickersPicker.module__searchResultsContainer___NEcwOE",
};

module.exports = exports;
